import React, { useEffect, useRef, useState } from "react";

export default function HostingRestrictionIcon(props) {
  const { hostingRestriction, color = "red", idiom } = props;

  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState("bottom"); // bottom | top

  const containerRef = useRef(null);
  const cardRef = useRef(null);

  // Fecha ao clicar fora
  useEffect(() => {
    function handleOutside(event) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleOutside);
      document.addEventListener("touchstart", handleOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
    };
  }, [open]);

  // Decide se abre acima ou abaixo
  useEffect(() => {
    if (!open || !containerRef.current || !cardRef.current) return;

    const iconRect = containerRef.current.getBoundingClientRect();
    const cardHeight = cardRef.current.offsetHeight;
    const viewportHeight = window.innerHeight;

    const spaceBelow = viewportHeight - iconRect.bottom;
    const spaceAbove = iconRect.top;

    if (spaceBelow < cardHeight + 12 && spaceAbove > cardHeight + 12) {
      setPlacement("top");
    } else {
      setPlacement("bottom");
    }
  }, [open]);

  if (!hostingRestriction) return null;

  return (
    <span
      ref={containerRef}
      style={{
        position: "relative",
        display: "inline-block",
        marginLeft: "10px",
      }}
    >
      {/* Ícone */}
      <span
        onClick={() => setOpen((prev) => !prev)}
        style={{
          cursor: "pointer",
          padding: "6px",
          display: "inline-block",
          touchAction: "manipulation",
        }}
      >
        <i className="mdi mdi-bed" style={{ color, fontSize: 20 }}></i>

        <i
          className="mdi mdi-sleep"
          style={{
            position: "absolute",
            top: "-6px",
            right: "-4px",
            color,
            fontSize: 14,
          }}
        ></i>
      </span>

      {/* Card */}
      {open && (
        <div
          ref={cardRef}
          style={{
            position: "absolute",
            [placement === "bottom" ? "top" : "bottom"]: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            marginTop: placement === "bottom" ? "8px" : undefined,
            marginBottom: placement === "top" ? "8px" : undefined,
            zIndex: 999,
            width: "260px",
            maxWidth: "90vw",
            backgroundColor: "#fff",
            borderRadius: "10px",
            boxShadow: "0 8px 20px rgba(0,0,0,0.18)",
            padding: "14px",
            animation: "fadeScale 0.18s ease-out",
            textAlign: "left",
          }}
        >
          {/* Arrow */}
          <div
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              ...(placement === "bottom"
                ? {
                    top: "-8px",
                    borderLeft: "8px solid transparent",
                    borderRight: "8px solid transparent",
                    borderBottom: "8px solid white",
                  }
                : {
                    bottom: "-8px",
                    borderLeft: "8px solid transparent",
                    borderRight: "8px solid transparent",
                    borderTop: "8px solid white",
                  }),
            }}
          />

          <div style={{ fontWeight: 600, marginBottom: "6px" }}>
            {idiom("Restrição de Hospedagem")}
          </div>

          <div style={{ fontSize: "13px", color: "#555", lineHeight: 1.45 }}>
            {hostingRestriction}
          </div>
        </div>
      )}

      <style>
        {`
          @keyframes fadeScale {
            from {
              opacity: 0;
              transform: translateX(-50%) scale(0.92);
            }
            to {
              opacity: 1;
              transform: translateX(-50%) scale(1);
            }
          }
        `}
      </style>
    </span>
  );
}
